import styled from "styled-components";

const Container = styled.div`
  padding: 25px 45px 0px 55px;
  //height: 100%;
`;

const DashboardTitle = styled.div`
  font-size: 29px;
  font-weight: 400;
  margin-bottom: 20px;
`;

export { Container, DashboardTitle };
